/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { InsuranceFundFake } from "./InsuranceFundFake";

export class InsuranceFundFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<InsuranceFundFake> {
    return super.deploy(overrides || {}) as Promise<InsuranceFundFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): InsuranceFundFake {
    return super.attach(address) as InsuranceFundFake;
  }
  connect(signer: Signer): InsuranceFundFakeFactory {
    return super.connect(signer) as InsuranceFundFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InsuranceFundFake {
    return new Contract(address, _abi, signerOrProvider) as InsuranceFundFake;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "ShutdownAllAmms",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "TokenAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "TokenRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "withdrawer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "addAmm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchange",
    outputs: [
      {
        internalType: "contract IExchangeWrapper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllAmms",
    outputs: [
      {
        internalType: "contract IAmm[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getQuoteTokenLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inflationMonitor",
    outputs: [
      {
        internalType: "contract IInflationMonitor",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "isExistedAmm",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minter",
    outputs: [
      {
        internalType: "contract IMinter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "perpToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "quoteTokens",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "removeAmm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "removeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
    ],
    name: "setBeneficiary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IExchangeWrapper",
        name: "_exchange",
        type: "address",
      },
    ],
    name: "setExchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IInflationMonitor",
        name: "_inflationMonitor",
        type: "address",
      },
    ],
    name: "setInflationMonitor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMinter",
        name: "_minter",
        type: "address",
      },
    ],
    name: "setMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shutdownAllAmm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_exceptionQuoteToken",
        type: "address",
      },
    ],
    name: "testGetOrderedQuoteTokens",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "orderedTokens",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_quoteToken",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052635611c23061016b5561271161016c5534801561002057600080fd5b50612c51806100306000396000f3fe608060405234801561001057600080fd5b50600436106101a85760003560e01c80639432665a116100f9578063c68ade3711610097578063cf23097911610071578063cf2309791461031d578063d2f7265a14610330578063d926de1c14610338578063fca3b5aa1461034b576101a8565b8063c68ade37146102fa578063c77f7c611461030d578063ca58b19814610315576101a8565b8063b7538c62116100d3578063b7538c62146102b5578063b7d25e22146102ca578063bc5920ba146102dd578063beb0597a146102e5576101a8565b80639432665a146102925780639cadb3a0146102a55780639dd96eb2146102ad576101a8565b80632c9115c7116101665780636c8381f8116101405780636c8381f814610272578063715018a61461027a5780638129fc1c146102825780638da5cb5b1461028a576101a8565b80632c9115c7146102395780635fa7b5841461024c57806367b1f5df1461025f576101a8565b8062c141b6146101ad57806307546172146101c25780630774a784146101e057806313af4035146102005780631c31f71014610213578063252978b814610226575b600080fd5b6101c06101bb3660046125a4565b61035e565b005b6101ca610364565b6040516101d791906125f0565b60405180910390f35b6101f36101ee3660046124c3565b610374565b6040516101d7919061266a565b6101c061020e3660046124c3565b610393565b6101c06102213660046124c3565b610475565b6101c061023436600461251b565b6104cd565b6101ca6102473660046125a4565b610650565b6101c061025a3660046124c3565b610678565b6101c061026d3660046124c3565b61087f565b6101ca6108d7565b6101c06108e7565b6101c0610966565b6101ca6109f9565b6101c06102a03660046125a4565b610a08565b6101ca610a0e565b6101c0610a1e565b6102bd610ba6565b6040516101d7919061261d565b6102bd6102d83660046124c3565b610c09565b6101c0610c1a565b6102ed610cdd565b6040516101d79190612baa565b6101c06103083660046124c3565b610ce4565b6102ed610d3c565b6101ca610d4b565b6101c061032b3660046124c3565b610d5b565b6101ca610ebd565b6101c06103463660046124c3565b610ecd565b6101c06103593660046124c3565b6110a5565b61016c55565b610136546001600160a01b031681565b6001600160a01b03166000908152610130602052604090205460ff1690565b61039b611193565b6065546001600160a01b039081169116146103d15760405162461bcd60e51b81526004016103c890612b0d565b60405180910390fd5b6001600160a01b0381166103f75760405162461bcd60e51b81526004016103c890612961565b6065546001600160a01b03828116911614156104255760405162461bcd60e51b81526004016103c890612b5a565b6066546001600160a01b03828116911614156104535760405162461bcd60e51b81526004016103c8906127cb565b606680546001600160a01b0319166001600160a01b0392909216919091179055565b61047d611193565b6065546001600160a01b039081169116146104aa5760405162461bcd60e51b81526004016103c890612b0d565b61013880546001600160a01b0319166001600160a01b0392909216919091179055565b6104d5611193565b610138546001600160a01b039081169116146105035760405162461bcd60e51b81526004016103c89061275d565b61050c82611197565b6105285760405162461bcd60e51b81526004016103c8906128f0565b6105306124b0565b610539836111b6565b9050610544816111c8565b61055b6105563685900385018561255a565b6111c8565b11156105a1576105696124b0565b6105888261057c3686900386018661255a565b9063ffffffff6111cc16565b905061059484826111f8565b61059d846111b6565b9150505b6105b36105563684900384018461255a565b6105bc826111c8565b10156105da5760405162461bcd60e51b81526004016103c890612ae4565b6105fa836105e6611193565b6105f53686900386018661255a565b611488565b7f7084f5476618d8e60b11ef0d7d3f06914655adb8793e28ff7f018d4c76d505d5610623611193565b6106356105563686900386018661255a565b604051610643929190612604565b60405180910390a1505050565b610133818154811061065e57fe5b6000918252602090912001546001600160a01b0316905081565b610680611193565b6065546001600160a01b039081169116146106ad5760405162461bcd60e51b81526004016103c890612b0d565b6106b681611197565b6106d25760405162461bcd60e51b81526004016103c8906126fb565b6001600160a01b038116600090815261013160205260408120805460ff191690556106fb610cdd565b905060005b818110156107e857826001600160a01b0316610133828154811061072057fe5b6000918252602090912001546001600160a01b031614156107e057600182038110156107ad57610133600183038154811061075757fe5b60009182526020909120015461013380546001600160a01b03909216918390811061077e57fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b6101338054806107b957fe5b600082815260209020810160001990810180546001600160a01b03191690550190556107e8565b600101610700565b5060006107f7610556846111b6565b11156108445760006108076115b7565b90506001600160a01b0381166108265750610135546001600160a01b03165b6108418382610834866111b6565b61083c61173c565b611757565b50505b7f4c910b69fe65a61f7531b9c5042b2329ca7179c77290aa7e2eb3afa3c8511fd38260405161087391906125f0565b60405180910390a15050565b610887611193565b6065546001600160a01b039081169116146108b45760405162461bcd60e51b81526004016103c890612b0d565b61013480546001600160a01b0319166001600160a01b0392909216919091179055565b6066546001600160a01b03165b90565b6108ef611193565b6065546001600160a01b0390811691161461091c5760405162461bcd60e51b81526004016103c890612b0d565b6065546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3606580546001600160a01b0319169055565b600054610100900460ff168061097f575061097f611856565b8061098d575060005460ff16155b6109a95760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff161580156109d4576000805460ff1961ff0019909116610100171660011790555b6109dc61185c565b6109e46118da565b80156109f6576000805461ff00191690555b50565b6065546001600160a01b031690565b61016b55565b610135546001600160a01b031681565b610a26611193565b6065546001600160a01b03908116911614610a535760405162461bcd60e51b81526004016103c890612b0d565b61013760009054906101000a90046001600160a01b03166001600160a01b0316633fe204d96040518163ffffffff1660e01b815260040160206040518083038186803b158015610aa257600080fd5b505afa158015610ab6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ada91906124df565b610ae357610ba4565b60005b61013254811015610b6b576101328181548110610aff57fe5b60009182526020822001546040805163fc0e74d160e01b815290516001600160a01b039092169263fc0e74d19260048084019382900301818387803b158015610b4757600080fd5b505af1158015610b5b573d6000803e3d6000fd5b505060019092019150610ae69050565b507ffc9f9c6cbb93f675af09b9bb43859333114dfa5e4c5abd35297e153f2434810143604051610b9b9190612baa565b60405180910390a15b565b6060610132805480602002602001604051908101604052809291908181526020018280548015610bff57602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311610be1575b5050505050905090565b6060610c1482611950565b92915050565b6066546001600160a01b0316610c425760405162461bcd60e51b81526004016103c890612a95565b610c4a611193565b6066546001600160a01b03908116911614610c775760405162461bcd60e51b81526004016103c890612812565b6066546065546040516001600160a01b0392831692909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a360668054606580546001600160a01b03199081166001600160a01b03841617909155169055565b6101335490565b610cec611193565b6065546001600160a01b03908116911614610d195760405162461bcd60e51b81526004016103c890612b0d565b61013780546001600160a01b0319166001600160a01b0392909216919091179055565b6000610d46611cdb565b905090565b610137546001600160a01b031681565b610d63611193565b6065546001600160a01b03908116911614610d905760405162461bcd60e51b81526004016103c890612b0d565b610d9981610374565b610db55760405162461bcd60e51b81526004016103c89061289a565b6001600160a01b038116600090815261013060205260408120805460ff1916905561013254905b81811015610eb857826001600160a01b03166101328281548110610dfc57fe5b6000918252602090912001546001600160a01b03161415610eb0576101326001830381548110610e2857fe5b60009182526020909120015461013280546001600160a01b039092169183908110610e4f57fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b03160217905550610132805480610e8957fe5b600082815260209020810160001990810180546001600160a01b0319169055019055610eb8565b600101610ddc565b505050565b610134546001600160a01b031681565b610ed5611193565b6065546001600160a01b03908116911614610f025760405162461bcd60e51b81526004016103c890612b0d565b610f0b81610374565b15610f285760405162461bcd60e51b81526004016103c8906129f1565b6001600160a01b038116600081815261013060209081526040808320805460ff191660019081179091556101328054918201815584527fc53bdfd4aa1ab65dfdaf681ca6bda958ae4a123d4ed68c4277796592280e78350180546001600160a01b03191685179055805163fdf262b760e01b8152905192939263fdf262b792600480840193919291829003018186803b158015610fc457600080fd5b505afa158015610fd8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ffc91906124ff565b905061100781611197565b6110a157610133805460018082019092557f92e985329fb94cc1b424ebb0f7f2929b6d27383ca94c0ec71c44fb48bdf96d2c0180546001600160a01b0319166001600160a01b0384169081179091556000908152610131602052604090819020805460ff1916909217909155517f784c8f4dbf0ffedd6e72c76501c545a70f8b203b30a26ce542bf92ba87c248a4906108739083906125f0565b5050565b6110ad611193565b6065546001600160a01b039081169116146110da5760405162461bcd60e51b81526004016103c890612b0d565b61013680546001600160a01b0319166001600160a01b0383811691909117918290556040805163eb7c8c2560e01b81529051929091169163eb7c8c2591600480820192602092909190829003018186803b15801561113757600080fd5b505afa15801561114b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061116f91906124ff565b61013580546001600160a01b0319166001600160a01b039290921691909117905550565b3390565b6001600160a01b03166000908152610131602052604090205460ff1690565b6111be6124b0565b610c148230611ce2565b5190565b6111d46124b0565b6111dc6124b0565b825184516111ef9163ffffffff611d7616565b81529392505050565b606061120383611950565b905060005b815181101561135d576112196124b0565b6112216124b0565b6101345484516001600160a01b039091169063c643ea639086908690811061124557fe5b602002602001015188886040518463ffffffff1660e01b815260040161126d93929190612675565b60206040518083038186803b15801561128557600080fd5b505afa158015611299573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112bd919061257f565b90506112de6105568585815181106112d157fe5b60200260200101516111b6565b6112e7826111c8565b116113185761130d8484815181106112fb57fe5b6020026020010151878361083c61173c565b9150505050506110a1565b61133f84848151811061132757fe5b6020026020010151876108348787815181106112d157fe5b9150611351858363ffffffff6111cc16565b94505050600101611208565b506000611369836111c8565b1115610eb8576113776124b0565b610134546101355460405163c643ea6360e01b81526001600160a01b039283169263c643ea63926113b19291169088908890600401612675565b60206040518083038186803b1580156113c957600080fd5b505afa1580156113dd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611401919061257f565b6101365460405163b90ffc4160e01b81529192506001600160a01b03169063b90ffc4190611433908490600401612ba0565b600060405180830381600087803b15801561144d57600080fd5b505af1158015611461573d6000803e3d6000fd5b50506101355461148192506001600160a01b03169050858361083c61173c565b5050505050565b61149183611db8565b6114996124b0565b6114a38484611ce2565b905060006114b18584611e02565b905060006060866001600160a01b031663a9059cbb60e01b87856040516024016114dc929190612604565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b031990941693909317909252905161151a91906125d4565b6000604051808303816000865af19150503d8060008114611557576040519150601f19603f3d011682016040523d82523d6000602084013e61155c565b606091505b509150915081801561158657508051158061158657508080602001905181019061158691906124df565b6115a25760405162461bcd60e51b81526004016103c890612726565b6115ae87878587611e78565b50505050505050565b61013354600090806115cd5760009150506108e4565b8060011415611603576101336000815481106115e557fe5b6000918252602090912001546001600160a01b031691506108e49050565b600061013360008154811061161457fe5b6000918252602090912001546001600160a01b03169050806116346124b0565b61163d836111b6565b905060015b84811015611732576000610133828154811061165a57fe5b6000918252602090912001546001600160a01b031690506116796124b0565b610134546001600160a01b031663c1094e5b8388611696826111b6565b6040518463ffffffff1660e01b81526004016116b493929190612675565b60206040518083038186803b1580156116cc57600080fd5b505afa1580156116e0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611704919061257f565b90506000611718828663ffffffff611ed116565b60000b1315611728578194508093505b5050600101611642565b5090935050505090565b6117446124b0565b5060408051602081019091526000815290565b61175f6124b0565b611768836111c8565b61177b5761177461173c565b905061184e565b610134546117949086906001600160a01b031685611f02565b610134546001600160a01b031663e5e75d1e868686866117b261173c565b6040518663ffffffff1660e01b81526004016117d2959493929190612698565b602060405180830381600087803b1580156117ec57600080fd5b505af1158015611800573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611824919061257f565b90506000611831826111c8565b1161184e5760405162461bcd60e51b81526004016103c8906128c3565b949350505050565b303b1590565b600054610100900460ff16806118755750611875611856565b80611883575060005460ff16155b61189f5760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff161580156118ca576000805460ff1961ff0019909116610100171660011790555b6118d2611f28565b6109e4611fa9565b600054610100900460ff16806118f357506118f3611856565b80611901575060005460ff16155b61191d5760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff16158015611948576000805460ff1961ff0019909116610100171660011790555b6109e4612083565b6060806101338054806020026020016040519081016040528092919081815260200182805480156119aa57602002820191906000526020600020905b81546001600160a01b0316815260019091019060200180831161198c575b50939450600093505050505b6119be610cdd565b811015611c0457600061013382815481106119d557fe5b6000918252602090912001546001600160a01b031690506119f46124b0565b61013454610135546001600160a01b039182169163c1094e5b91859116611a1a826111b6565b6040518463ffffffff1660e01b8152600401611a3893929190612675565b60206040518083038186803b158015611a5057600080fd5b505afa158015611a64573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a88919061257f565b9050825b8015611bf957611a9a6124b0565b6101345486516001600160a01b039091169063c1094e5b9088906000198601908110611ac257fe5b602002602001015161013560009054906101000a90046001600160a01b0316611af38a60018803815181106112d157fe5b6040518463ffffffff1660e01b8152600401611b1193929190612675565b60206040518083038186803b158015611b2957600080fd5b505afa158015611b3d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b61919061257f565b9050611b6c816111c8565b611b75846111c8565b1115611bef57856001830381518110611b8a57fe5b6020026020010151868381518110611b9e57fe5b60200260200101906001600160a01b031690816001600160a01b03168152505083866001840381518110611bce57fe5b60200260200101906001600160a01b031690816001600160a01b0316815250505b5060001901611a8c565b5050506001016119b6565b50600181510367ffffffffffffffff81118015611c2057600080fd5b50604051908082528060200260200182016040528015611c4a578160200160208202803683370190505b5091506000805b8251811015611cd357846001600160a01b0316838281518110611c7057fe5b60200260200101516001600160a01b03161415611c8c57611ccb565b828181518110611c9857fe5b6020026020010151848381518110611cac57fe5b6001600160a01b03909216602092830291909101909101526001909101905b600101611c51565b505050919050565b61016b5490565b611cea6124b0565b611d6f83846001600160a01b03166370a08231856040518263ffffffff1660e01b8152600401611d1a91906125f0565b60206040518083038186803b158015611d3257600080fd5b505afa158015611d46573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611d6a91906125bc565b612112565b9392505050565b6000611d6f83836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f7700008152506121a4565b6000611dc3826121d0565b6001600160a01b038316600090815260fd602052604090205490915081146110a1576001600160a01b0391909116600090815260fd6020526040902055565b600080611e0e846121d0565b905060128110611e4c57611e44611e2c82601263ffffffff611d7616565b600a0a611e38856111c8565b9063ffffffff6122bd16565b915050610c14565b61184e611e6060128363ffffffff611d7616565b600a0a611e6c856111c8565b9063ffffffff6122f716565b611eab611e95611e888685612112565b839063ffffffff61233916565b611e9f8686611ce2565b9063ffffffff611ed116565b60000b15611ecb5760405162461bcd60e51b81526004016103c890612a53565b50505050565b805182516000911015611ee657506001610c14565b815183511015611ef95750600019610c14565b50600092915050565b611f0b83611db8565b611f1d8383611f1861173c565b61235c565b610eb883838361235c565b600054610100900460ff1680611f415750611f41611856565b80611f4f575060005460ff16155b611f6b5760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff161580156109e4576000805460ff1961ff00199091166101001716600117905580156109f6576000805461ff001916905550565b600054610100900460ff1680611fc25750611fc2611856565b80611fd0575060005460ff16155b611fec5760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff16158015612017576000805460ff1961ff0019909116610100171660011790555b6000612021611193565b606580546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a35080156109f6576000805461ff001916905550565b600054610100900460ff168061209c575061209c611856565b806120aa575060005460ff16155b6120c65760405162461bcd60e51b81526004016103c8906129a3565b600054610100900460ff161580156120f1576000805460ff1961ff0019909116610100171660011790555b60cb805460ff1916600117905580156109f6576000805461ff001916905550565b61211a6124b0565b6000612125846121d0565b90506012811061216a5760408051602081019091528061215f61214f84601263ffffffff611d7616565b8690600a0a63ffffffff6122f716565b815250915050610c14565b60408051602081019091528061219a61218a60128563ffffffff611d7616565b8690600a0a63ffffffff6122bd16565b9052949350505050565b600081848411156121c85760405162461bcd60e51b81526004016103c891906126c8565b505050900390565b6001600160a01b038116600090815260fd602052604081205480610c145760408051600481526024810182526020810180516001600160e01b031663313ce56760e01b17905290516000916060916001600160a01b03871691612232916125d4565b600060405180830381855afa9150503d806000811461226d576040519150601f19603f3d011682016040523d82523d6000602084013e612272565b606091505b50915091508180156122845750805115155b6122a05760405162461bcd60e51b81526004016103c890612859565b808060200190518101906122b491906125bc565b95945050505050565b6000826122cc57506000610c14565b828202828482816122d957fe5b0414611d6f5760405162461bcd60e51b81526004016103c890612920565b6000611d6f83836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f000000000000815250612454565b6123416124b0565b6123496124b0565b825184516111ef9163ffffffff61248b16565b600060606001600160a01b03851663095ea7b360e01b8561237d8887611e02565b60405160240161238e929190612604565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b03199094169390931790925290516123cc91906125d4565b6000604051808303816000865af19150503d8060008114612409576040519150601f19603f3d011682016040523d82523d6000602084013e61240e565b606091505b509150915081801561243857508051158061243857508080602001905181019061243891906124df565b6114815760405162461bcd60e51b81526004016103c890612a1c565b600081836124755760405162461bcd60e51b81526004016103c891906126c8565b50600083858161248157fe5b0495945050505050565b600082820183811015611d6f5760405162461bcd60e51b81526004016103c890612794565b6040518060200160405280600081525090565b6000602082840312156124d4578081fd5b8135611d6f81612c06565b6000602082840312156124f0578081fd5b81518015158114611d6f578182fd5b600060208284031215612510578081fd5b8151611d6f81612c06565b600080828403604081121561252e578182fd5b833561253981612c06565b92506020601f198201121561254c578182fd5b506020830190509250929050565b60006020828403121561256b578081fd5b6125756020612bb3565b9135825250919050565b600060208284031215612590578081fd5b61259a6020612bb3565b9151825250919050565b6000602082840312156125b5578081fd5b5035919050565b6000602082840312156125cd578081fd5b5051919050565b600082516125e6818460208701612bda565b9190910192915050565b6001600160a01b0391909116815260200190565b6001600160a01b03929092168252602082015260400190565b6020808252825182820181905260009190848201906040850190845b8181101561265e5783516001600160a01b031683529284019291840191600101612639565b50909695505050505050565b901515815260200190565b6001600160a01b0393841681529190921660208201529051604082015260600190565b6001600160a01b039586168152939094166020840152905160408301525160608201529051608082015260a00190565b60006020825282518060208401526126e7816040850160208701612bda565b601f01601f19169190910160400192915050565b6020808252601190820152701d1bdad95b881b9bdd08195e1a5cdd1959607a1b604082015260600190565b6020808252601d908201527f446563696d616c45524332303a207472616e73666572206661696c6564000000604082015260600190565b60208082526019908201527f63616c6c6572206973206e6f742062656e656669636961727900000000000000604082015260600190565b6020808252601b908201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604082015260600190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a2073616d652061732063616040820152666e64696461746560c81b606082015260800190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a206e6f7420746865206e656040820152663b9037bbb732b960c91b606082015260800190565b60208082526021908201527f446563696d616c45524332303a2067657420646563696d616c73206661696c656040820152601960fa1b606082015260800190565b6020808252600f908201526e185b5b481b9bdd08195e1a5cdd1959608a1b604082015260600190565b60208082526013908201527222bc31b430b733b29039bbb0b81032b93937b960691b604082015260600190565b602080825260169082015275105cdcd95d081a5cc81b9bdd081cdd5c1c1bdc9d195960521b604082015260600190565b60208082526021908201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526022908201527f5065727046694f776e61626c65557067726164653a207a65726f206164647265604082015261737360f01b606082015260800190565b6020808252602e908201527f436f6e747261637420696e7374616e63652068617320616c726561647920626560408201526d195b881a5b9a5d1a585b1a5e995960921b606082015260800190565b602080825260119082015270185b5b48185b1c9958591e481859191959607a1b604082015260600190565b6020808252601c908201527f446563696d616c45524332303a20617070726f7665206661696c656400000000604082015260600190565b60208082526022908201527f446563696d616c45524332303a2062616c616e636520696e636f6e73697374656040820152611b9d60f21b606082015260800190565b6020808252602f908201527f5065727046694f776e61626c65557067726164653a2063616e6469646174652060408201526e6973207a65726f206164647265737360881b606082015260800190565b6020808252600f908201526e08ceadcc840dcdee840cadcdeeaced608b1b604082015260600190565b6020808252602d908201527f5065727046694f776e61626c65557067726164653a2063616c6c65722069732060408201526c3737ba103a34329037bbb732b960991b606082015260800190565b60208082526026908201527f5065727046694f776e61626c65557067726164653a2073616d65206173206f726040820152651a59da5b985b60d21b606082015260800190565b9051815260200190565b90815260200190565b60405181810167ffffffffffffffff81118282101715612bd257600080fd5b604052919050565b60005b83811015612bf5578181015183820152602001612bdd565b83811115611ecb5750506000910152565b6001600160a01b03811681146109f657600080fdfea2646970667358221220ac3502cad310adaed2c141a6f04911942f4bb2cb9317a8f756f9339d0a5fa89f64736f6c63430006090033";
